import { Modal } from 'antd'
import React, { useState } from 'react'
import CountdownProgressBar from './CountdownProgressBar'
import Lottie from 'lottie-react'
import animationData from "../../lotties/PaymentSuccessfulLottie.json";
import confettiAnimationData from "../../lotties/confetti.json";
import './successModal.css'
import { ReactComponent as OfferTagIcon } from '../../../../assets/Offers/OfferTag.svg'
import { hexToRGBA, numberToCurrency } from '../../../../Utils/utils';
import TranslateText from '../../../resuableComponents/TranslateText';
import { selectCurrencyCode } from '../../../../slices/PaymentSessionDetailsSlice';
import { useSelector } from 'react-redux';
import CustomButton from '../../../resuableComponents/CustomButton';


function SuccessModal({ appliedCoupon, baseColor, setShowModal, showModal }) {

    const appliedOfferDetail = useSelector(state => state.offers.appliedOfferDetail);
    const couponBackgroundColor = hexToRGBA(baseColor, 0.1)
    const currencyCode = useSelector(selectCurrencyCode);
    const [showConfetti, setShowConfetti] = useState(true)
    const sessionDetails = useSelector((state) => state.paymentSessionDetails.sessionDetails);
    const frontendReturnUrl = sessionDetails?.paymentDetails?.frontendReturnUrl;
    const [loader, setLoader] = useState(false);


    const handleOnProgressComplete = () => {
        if (appliedOfferDetail?.finalAmount) {
            setShowModal(false)
        } else {
            setShowConfetti(false)
        }

    }

    const handleRedirectToUrl = () => {
        setLoader(true)
        window.location.replace(frontendReturnUrl)
    }


    return (
        <Modal
            centered
            open={showModal}
            footer={null}
            closable={appliedOfferDetail?.finalAmount ? true : false}
            onCancel={() => appliedOfferDetail?.finalAmount ? setShowModal(false) : ""}
            width={appliedOfferDetail?.finalAmount ? "328px" : "600px"}
        >
            <div className='successModalContainer' style={{ gap: appliedOfferDetail?.finalAmount ? "10px" : "20px" }}>
                <Lottie
                    animationData={animationData}
                    loop={false}
                    autoplay={true}
                    style={{ width: "70px", height: "70px" }}
                    speed={4.5}
                />
                {!appliedOfferDetail?.finalAmount && <div className='secondaryText' style={{ fontSize: "20px" }}>
                    <TranslateText label={"YOUR_PAYMENT_IS_COMPLETE"}>   Your payment is complete </TranslateText>
                </div>}
                {showConfetti && <div className='confettiContainer' style={{ position: "absolute" }}>
                    <Lottie
                        animationData={confettiAnimationData}
                        loop={appliedOfferDetail?.finalAmount ? true : false}
                        autoplay={true}
                        style={{ width: "200px" }}
                        speed={4.5}
                    />
                </div>}
                <div className='couponCodeContainer' style={{ background: couponBackgroundColor, borderColor: baseColor }}>
                    <OfferTagIcon style={{ color: baseColor, height: "16px" }} />
                    <span className='couponText'>  `{appliedCoupon?.code}`  <TranslateText label={"APPLIED_TEXT"}>Applied </TranslateText>! </span >
                </div>
                <div className='secondaryText' style={{ fontSize: appliedOfferDetail?.finalAmount ? "24px" : "18px" }}>
                    <TranslateText label={"YOU_SAVED_TEXT"}>   You saved </TranslateText>  <span className="currency-symbol" style={{ fontWeight: 500 }}> {currencyCode} </span> {numberToCurrency(appliedCoupon?.appliedDiscountAmount, currencyCode)}
                </div>

                {!!appliedOfferDetail?.finalAmount ? <button className='actionBtn' style={{ color: baseColor }} onClick={() => setShowModal(false)}> <TranslateText label={"YAY_TEXT"}>YAY! </TranslateText></button> :
                    <CustomButton
                        padding="9px 40px"
                        fontSize="18px"
                        loading={loader}
                        disabled={loader}
                        text={
                            <div className={`dynamic-font-family  'dynamic-button-text`}
                                style={{ color: sessionDetails?.merchantDetails?.checkoutTheme?.buttonTextColor }}>
                                <TranslateText label={"NOTING_DUE_TEXT"}>Nothing Due - Click to Proceed! </TranslateText>
                            </div>
                        }
                        onClick={handleRedirectToUrl}
                    />}
            </div>
            < CountdownProgressBar appliedOfferDetail={appliedOfferDetail} height={"10px"} color={baseColor} onProgressComplete={handleOnProgressComplete} />
        </Modal>
    )

}

export default SuccessModal